/* eslint-disable */
// @ts-nocheck

import { Route, Routes } from "react-router-dom";
import { routes } from "./routes";
import PrivateWrapper from "./ProtectedRoute";

export default function Router() {
  return (
    <>
      {/* <BrowserRouter> */}
      <Routes>
        {routes.map(({ path, component, ...rest }) => (
          <Route
            path={path}
            key={path}
            element={<PrivateWrapper {...rest}>{component}</PrivateWrapper>}
          />
        ))}
      </Routes>
      {/* </BrowserRouter> */}
    </>
  );
}
